// cart-upsell.js — « you added mantra. make it 3 kits −30% » (snippets/cart-upsell, at the top of the cart
// drawer). After a kit is added (the cart's kit count goes up) and the drawer holds the offer, the drawer
// opens on it — a card's « + add » too, which otherwise only shows the add bar. Once per session: seen when
// the drawer that showed it closes, or at « no thanks » (sessionStorage; html.ups-seen hides it).
// The sum: the cart's kits + the ones proposed, each line less its discount rounded down to the cent (as
// Shopify does), the better of the 3-kit tier and the launch sale while it runs. « swap » opens, under the
// list, every kit free to take that one's place; a tap puts it there. The key: the proposed kits into the
// cart in one request (DRAYKI.cart.addMany: /cart/add.js, so the pixel's AddToCart fires again); the cart
// stays open, drawn again with the discount.
(() => {
  const W = window, doc = document, root = doc.documentElement, KEY = 'drayki-ups';
  const $ = (s, r = doc) => r.querySelector(s);
  const $$ = (s, r = doc) => Array.from(r.querySelectorAll(s));
  const seen = () => { try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; } };
  const markSeen = () => { try { sessionStorage.setItem(KEY, '1'); } catch (e) {} root.classList.add('ups-seen'); };
  if (seen()) root.classList.add('ups-seen');
  const fmt = (c) => { const D = W.DRAYKI; return D && typeof D.fmt === 'function' ? D.fmt(c) : (c / 100).toFixed(2); };
  const esc = (t) => String(t).replace(/[&<>"]/g, (m) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]));

  const box = () => $('#cart-drawer [data-ups]');
  const offer = () => (seen() ? null : box());
  const drawer = () => doc.getElementById('cart-drawer');

  /* ---------------------------------------------------------- the sum */
  function draw(u) {
    if (!u) return;
    const end = Date.parse(u.dataset.promoEnd || ''), poff = +u.dataset.promoOff || 0, tier = +u.dataset.off || 30;
    const off = Math.max(tier, poff > 0 && end && Date.now() < end ? poff : 0);
    const line = (p) => p - Math.floor((p * off) / 100);
    const rows = $$('[data-in]', u).map((r) => ({ p: +r.dataset.p, q: +r.dataset.q || 1, n: +r.dataset.n || 0 }))
      .concat($$('[data-c][data-on]', u).map((r) => ({ p: +r.dataset.p, q: 1, n: +r.dataset.n || 0 })));
    const w = rows.reduce((a, r) => a + r.p * r.q, 0);
    const pr = rows.reduce((a, r) => a + line(r.p) * r.q, 0);
    const n = rows.reduce((a, r) => a + r.n * r.q, 0);
    const set = (s, t) => { const el = $(s, u); if (el) el.textContent = t; };
    set('[data-ups-n]', n.toLocaleString('en-US'));
    set('[data-ups-p]', fmt(pr));
    set('[data-ups-w]', fmt(w));
    set('[data-ups-off]', `−${off}%`);
    const sv = $('[data-ups-save]', u);
    if (sv) { sv.textContent = `you save ${fmt(w - pr)}`; sv.hidden = !(w > pr); }
    const go = $('[data-ups-go]', u), need = +(go && go.dataset.need) || 2;
    set('[data-ups-lb]', `add ${need} kit${need > 1 ? 's' : ''} · ${fmt(pr)} for all 3`);
    for (const c of $$('[data-c]', u)) c.hidden = !c.hasAttribute('data-on');
  }
  // (drawn now, and each time the cart's sections bring the drawer back)
  draw(box());

  /* ---------------------------------------------------- the opening */
  let kits = 0;
  try { kits = +JSON.parse((doc.querySelector('[data-cart-state]') || {}).textContent || '{}').kits || 0; } catch (e) {}
  let shown = false;
  doc.addEventListener('drayki:cart', (e) => {
    draw(box());
    const items = (e.detail && e.detail.items) || [];
    const n = items.filter((i) => i.kit).reduce((a, i) => a + (+i.qty || 0), 0);
    const up = n > kits;
    kits = n;
    if (!up || !offer()) return;
    // (after the add's own step: a card's add bar comes up first, the drawer then puts it away)
    setTimeout(() => {
      const d = drawer();
      if (d && !d.classList.contains('open') && typeof W.openCartDrawer === 'function') W.openCartDrawer();
      const body = $('#cart-drawer [data-dw-body]');
      if (body) body.scrollTop = 0;
      shown = true;
    }, 40);
  });
  // (the drawer opened by hand on the offer counts too; it is seen once that drawer closes)
  W.addEventListener('drayki:overlay', (e) => {
    const open = !!(e.detail && e.detail.open);
    const d = drawer();
    if (open && d && d.classList.contains('open') && offer()) shown = true;
    else if (!open && shown) { shown = false; markSeen(); }
  });

  /* ------------------------------------------------------ the picker */
  let slot = null;
  const closePick = (u, focus) => {
    const pk = u && $('.ups-pick', u);
    if (pk) pk.remove();
    for (const b of $$('[data-ups-swap]', u || doc)) b.setAttribute('aria-expanded', 'false');
    if (focus && slot && slot.isConnected) { const b = $('[data-ups-swap]', slot); if (b) b.focus(); }
    slot = null;
  };
  const openPick = (u, c) => {
    if (slot === c) { closePick(u, true); return; }
    closePick(u);
    slot = c;
    const name = ($('.ups-kn', c) || {}).textContent || '';
    const end = Date.parse(u.dataset.promoEnd || ''), poff = +u.dataset.promoOff || 0;
    const off = Math.max(+u.dataset.off || 30, poff > 0 && end && Date.now() < end ? poff : 0);
    const free = $$('[data-c]:not([data-on])', u);
    const pk = doc.createElement('div');
    pk.className = 'ups-pick';
    pk.setAttribute('role', 'group');
    pk.setAttribute('aria-label', `pick a kit instead of ${name}`);
    pk.innerHTML = `<div class="ups-ph"><p>pick a kit instead of <b>${esc(name)}</b></p><button type="button" class="ups-px" data-ups-close aria-label="close">×</button></div><ul class="ups-pg">${free.map((x) => {
      const img = $('img', x), p = +x.dataset.p;
      return `<li><button type="button" class="ups-po" data-ups-pick="${esc(x.dataset.h)}"><span class="ups-pc">${img ? `<img src="${esc(img.currentSrc || img.src)}" alt="" width="120" height="120" loading="lazy">` : ''}</span><span class="ups-pn">${esc(($('.ups-kn', x) || {}).textContent || '')}</span><span class="ups-pm">${esc(($('.ups-km', x) || {}).textContent || '')}</span><span class="ups-pp">${esc(fmt(p - Math.floor((p * off) / 100)))}</span></button></li>`;
    }).join('')}</ul>`;
    $('[data-ups-list]', u).after(pk);
    const b = $('[data-ups-swap]', c); if (b) b.setAttribute('aria-expanded', 'true');
    const first = $('[data-ups-pick]', pk); if (first) first.focus({ preventScroll: true });
    pk.scrollIntoView({ block: 'nearest', behavior: W.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  };

  doc.addEventListener('keydown', (e) => { if (e.key === 'Escape' && slot) { const u = box(); if (u) { e.stopPropagation(); closePick(u, true); } } }, true);

  doc.addEventListener('click', (e) => {
    const t = e.target;
    if (!t || !t.closest) return;
    const u = t.closest('[data-ups]');
    if (!u) return;
    if (t.closest('[data-ups-no]')) { markSeen(); shown = false; return; }
    const sw = t.closest('[data-ups-swap]');
    if (sw) { openPick(u, sw.closest('[data-c]')); return; }
    if (t.closest('[data-ups-close]')) { closePick(u, true); return; }
    const po = t.closest('[data-ups-pick]');
    if (po && slot) {
      const next = $$('[data-c]', u).find((x) => x.dataset.h === po.dataset.upsPick);
      if (next) {
        slot.removeAttribute('data-on');
        next.setAttribute('data-on', '');
        slot.before(next);
        slot = next;
        draw(u);
        closePick(u, true);
      }
      return;
    }
    const go = t.closest('[data-ups-go]');
    if (!go || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
    const api = W.DRAYKI && W.DRAYKI.cart;
    if (!api || typeof api.addMany !== 'function') return;
    e.preventDefault();
    if (go.getAttribute('aria-busy') === 'true') return;
    go.setAttribute('aria-busy', 'true');
    const ids = $$('[data-c][data-on]', u).map((c) => c.dataset.v).filter(Boolean);
    markSeen();
    api.addMany(ids, { open: true, from: go }).then(() => {
      const body = $('#cart-drawer [data-dw-body]'); if (body) body.scrollTop = 0;
    }, () => { location.href = go.href; });
  });
  W.addEventListener('pageshow', () => { for (const a of $$('[data-ups-go][aria-busy]')) a.removeAttribute('aria-busy'); });
})();
